const utilityServices = [
  {
    id: 'text-analyzer',
    title: '텍스트 분석기',
    description: '글자수, 단어수, 문장수를 세고 읽기 시간을 예측합니다.',
    icon: 'DocumentTextIcon',
    path: '/services/tools/utilities/text-analyzer',
    component: 'TextAnalyzer',
    category: 'utilities'
  },
  {
    id: 'unit-converter',
    title: '단위 변환기',
    description: '길이, 무게, 온도 등 다양한 단위를 변환합니다.',
    icon: 'ArrowsRightLeftIcon',
    path: '/services/tools/utilities/unit-converter',
    component: 'UnitConverter',
    category: 'utilities'
  },
  {
    id: 'date-calculator',
    title: '날짜 계산기',
    description: '두 날짜 간의 차이를 계산하거나 특정 날짜에 일수를 더하고 뺍니다.',
    icon: 'CalendarIcon',
    path: '/services/tools/utilities/date-calculator',
    component: 'DateCalculator',
    category: 'utilities'
  },
  {
    id: 'qr-generator',
    title: 'QR 코드 생성기',
    description: 'URL, 연락처, Wi-Fi 등의 정보를 QR 코드로 변환합니다.',
    icon: 'QrCodeIcon',
    path: '/services/tools/utilities/qr-generator',
    component: 'QRCodeGenerator',
    category: 'utilities'
  }
];

export default utilityServices; 